import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import PageContainer from '@/components/Container/PageContainer';
import { Flex, LoadingPage } from '@/layout';
import { Button } from '@/components/UI/Button';
import { Check } from '@/components/Icon';
import { useAppSelector } from '@/redux/store.hook';
import { getCartSelector } from '@/redux/cart/cart.slice';
import { theme } from '@/theme/Theme';
import useUserDetail from '@/hooks/useUserDetail';
import { useDispatch } from 'react-redux';
import { getAuthSelector, update } from '@/redux/auth/auth.slice';
import { sendCertApplyOrder } from '@/api/eCert.api';
import { submitLEI } from '@/api/lei.api';
import { errorHandler } from '@/utils/toastHandler';

const Text = styled.p`
  font-size: ${(p) => p.theme.fontSizes.md};
  color: ${(p) => p.theme.colors.gray300};
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 930px;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(p) => p.theme.colors.light};
  border-radius: 15px;
`;

const StripeCancel = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const cart = useAppSelector(getCartSelector);
  const auth = useAppSelector(getAuthSelector);
  const userDetail = useUserDetail({});
  const dispatch = useDispatch();

  // 進入此頁時, 更新user資料
  useEffect(() => {
    if (!auth.isLogin) return;
    if (!userDetail) return;
    dispatch(update({ ...auth, userData: userDetail }));
  }, [userDetail]);

  return (
    <PageContainer title={t('paymentCancel')}>
      <LoadingPage isLoading={isLoading} />

      <FormWrapper>
        <Flex flexDirection={'column'} gridGap={15} alignItems={'center'}>
            <Check.CancelSVG fill={theme.colors.danger} width="96" height="96" />
          <Text>{t('paymentCancel')}</Text>
        </Flex>
        <Flex gridGap={20} justifyContent={'center'} marginTop={50}>
          <Link to={'/home'}>
            <Button size={'lg'} variant={'primary'} rounded={false} width={250}>
              {t('buttons.home')}
            </Button>
          </Link>
          <Link to={`${cart.returnURL === '' ? '/' : cart.returnURL}`}>
            <Button size={'lg'} variant={'primary'} rounded={false} width={250}>
              {t('buttons.backToPreviousStep')}
            </Button>
          </Link>
        </Flex>
      </FormWrapper>
    </PageContainer>
  );
};

export default StripeCancel;
